/**
 * The student app's handle on `@modulus/api`.
 *
 * Same-origin `/api/v1`: in production the BFF Worker is bound to `/api/*` on this
 * subdomain, and in development Vite proxies the same path to `wrangler dev`.
 */

import { createApi, localStorageSession } from '@modulus/api'

const store = localStorageSession()

export const api = createApi({ store })
export const client = api.client
export const sessionStore = store
